import React from "react";
import { interpolate, useCurrentFrame, Easing } from "remotion";

export interface AnimatedCounterProps {
  from?: number;
  to: number;
  delay?: number;
  durationInFrames?: number;
  prefix?: string;
  suffix?: string;
  decimals?: number;
  style?: React.CSSProperties;
}

/**
 * AnimatedCounter Component
 * Angka counter mulus berbasis frame rate & Easing bezier.
 */
export const AnimatedCounter: React.FC<AnimatedCounterProps> = ({
  from = 0,
  to,
  delay = 0,
  durationInFrames = 30,
  prefix = "",
  suffix = "",
  decimals = 0,
  style,
}) => {
  const frame = useCurrentFrame();

  const currentVal = interpolate(
    frame - delay,
    [0, durationInFrames],
    [from, to],
    {
      easing: Easing.bezier(0.16, 1, 0.3, 1),
      extrapolateLeft: "clamp",
      extrapolateRight: "clamp",
    }
  );

  const formatted = decimals > 0 ? currentVal.toFixed(decimals) : Math.round(currentVal).toLocaleString("id-ID");

  return (
    <span
      style={{
        fontVariantNumeric: "tabular-nums",
        display: "inline-block",
        ...style,
      }}
    >
      {prefix}
      {formatted}
      {suffix}
    </span>
  );
};
